/**
 * Logger conditionnel - Affiche les logs uniquement en développement
 * En production, seules les erreurs sont loggées
 */

const isDev = import.meta.env.DEV;
const isDebug = import.meta.env.VITE_DEBUG === 'true';

interface Logger {
  debug: (...args: unknown[]) => void;
  log: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  group: (label: string) => void;
  groupEnd: () => void;
  table: (data: unknown) => void;
}

const noop = () => {};

const createLogger = (): Logger => {
  if (isDev || isDebug) {
    // En développement, tous les logs sont actifs
    return {
      debug: (...args) => console.debug('[DEBUG]', ...args),
      log: (...args) => console.log(...args),
      info: (...args) => console.info('[INFO]', ...args),
      warn: (...args) => console.warn('[WARN]', ...args),
      error: (...args) => console.error('[ERROR]', ...args),
      group: (label) => console.group(label),
      groupEnd: () => console.groupEnd(),
      table: (data) => console.table(data),
    };
  }

  // En production, seules les erreurs sont loggées
  return {
    debug: noop,
    log: noop,
    info: noop,
    warn: noop,
    error: (...args) => console.error('[ERROR]', ...args),
    group: noop,
    groupEnd: noop,
    table: noop,
  };
};

export const logger = createLogger();

// Alias pour faciliter la migration
export default logger;
